import Vue from 'vue'
import VueRouter from 'vue-router'

import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'
import Dashboard from '@/pages/Dashboard.vue'
import NewDashboard from '@/pages/NewDashboard.vue'
import UserSource from '@/pages/UserSource.vue'
import UserRegisterProfile from '@/pages/UserRegisterProfile.vue'
import LoginProfile from '@/pages/LoginProfile.vue'
import Contacts from '@/pages/Contacts.vue'
import Admin from '@/pages/Admin.vue'
import Landing from '@/pages/Landing.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/home',
    children: [
      {
        path: 'dashboard',
        name: 'NewDashboard',
        component: NewDashboard
      },
      {
        path: 'streams',
        name: 'streams',
        component: Dashboard
      },
      {
        path: 'sources',
        name: 'UserSource',
        component: UserSource
      },
      {
        path: 'admin',
        name: 'Admin',
        component: Admin
      },
      {
        path: 'contacts',
        name: 'contacts',
        component: Contacts
      },
      {
        path: 'signup',
        name: 'Signup',
        component: UserRegisterProfile
      },
      {
        path: 'login',
        name: 'Login',
        component: LoginProfile
      }
    ]
  },
  {
    path: '/home',
    component: Landing
  }
]

export const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/signup', '/login', '/home', '/']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('token') // eslint-disable-line

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  next()
})
